'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n        width: ', 'px;\n        text-align: center;\n      '], ['\n        width: ', 'px;\n        text-align: center;\n      ']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: ', ';\n  align-items: center;\n  margin: 0px ', 'px;\n  font-size: ', 'px;\n  ', ';\n'], ['\n  display: ', ';\n  align-items: center;\n  margin: 0px ', 'px;\n  font-size: ', 'px;\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getWidth = function getWidth(_ref) {
  var simple = _ref.simple,
      small = _ref.small;
  return !simple ? '' : (0, _styledComponents.css)(_templateObject, small ? 30 : 40);
};

var PaginationContent = _styledComponents2.default.div(_templateObject2, function (_ref2) {
  var simple = _ref2.simple;
  return simple ? 'block' : 'flex';
}, function (_ref3) {
  var small = _ref3.small;
  return small ? 5 : 10;
}, function (_ref4) {
  var small = _ref4.small;
  return small ? 10 : 12;
}, getWidth);

exports.default = PaginationContent;